export default {
  NO_EMAIL_ADDRESS: 'no_email_address'
}
